import forexTemplate from '@/feature/TrHistory/store/template';
import { ModuleTree } from 'vuex';
import { IStoreRootState } from '@/store/interface';
import { FOREX_TEMPLATE_MODULE_NAME } from '@/feature/TrHistory/store/template/constants';

export default <ModuleTree<IStoreRootState>> {
	[FOREX_TEMPLATE_MODULE_NAME]: forexTemplate,
}
